var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "v6/solid/xmark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.0594 16.9408C19.6453 17.5268 19.6453 18.476 19.0594 19.0619C18.7688 19.3549 18.3844 19.5002 18 19.5002C17.6156 19.5002 17.2322 19.3537 16.9397 19.0607L12 14.1236L7.06078 19.0596C6.76781 19.3549 6.38391 19.5002 6 19.5002C5.61609 19.5002 5.23266 19.3549 4.93945 19.0596C4.35352 18.4736 4.35352 17.5244 4.93945 16.9385L9.88008 11.9979L4.93945 7.05957C4.35352 6.47363 4.35352 5.52441 4.93945 4.93848C5.52539 4.35254 6.47461 4.35254 7.06055 4.93848L12 9.88145L16.9406 4.94082C17.5266 4.35488 18.4758 4.35488 19.0617 4.94082C19.6477 5.52676 19.6477 6.47598 19.0617 7.06191L14.1211 12.0025L19.0594 16.9408Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.7a35d24b442381d7728a3758979085cc.svg";
export { ForwardRef as ReactComponent };